import { getResponseErrors } from "../getResponseErrors";

export const isResponseOk = (response) =>
  !!response?.ok && getResponseErrors(response)?.length === 0;
